var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 2H2C0.9 2 0.00999999 2.9 0.00999999 4L0 16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V4C20 2.9 19.1 2 18 2ZM17 16H3C2.45 16 2 15.55 2 15V6L8.94 10.34C9.59 10.75 10.41 10.75 11.06 10.34L18 6V15C18 15.55 17.55 16 17 16ZM10 9L2 4H18L10 9Z","fill":"#323232"}));
}

Mail.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
